/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { Button, CheckboxControlsList, Modal, RadiobuttonControlsList } from '@marriott/mi-ui-library';
import { BrandFilter } from '@marriott/mi-shop-components';
import { usePersistentGlobalStore } from '@marriott/mi-store-utils';
import { INTERNAL_CTA_TYPE, EN_LOCALE } from 'libs/mi-offers-components/src/constants/CommonConstants';
import { ShowAvailabilityFilter } from './availabilityFilters/availabilityFilter';
import { ShowPriceTaxFilter } from './priceTaxFilter/priceTaxFilter';
import {
  BrandProps,
  CheckboxControlsListProps,
  ControlsProps,
  PropertiesFilterProps,
  availableBrandsType,
  brandCategoriesDataType,
  brandCategoryTitleMappingType,
  brandFilterProps,
} from './PropertiesListFilter.types';
import { StyledSearchAllFilters } from './PropertiesListFilter.styles';

export const PropertiesListFilter: React.FC<PropertiesFilterProps> = props => {
  const hidePriceRangeFilter = props.acceptLanguage !== EN_LOCALE ? true : false;
  const model = props?.model;
  const { isCategoryRenderer = false } = props;
  const hasQuickFilter = (tag: string) =>
    isCategoryRenderer && model?.quickFilterList?.some((filter: any) => filter?.quickFilterTag === tag);
  const { amenities, activities, hotelType } = props?.destinationMetaData ?? {};
  const defaultFilterCount = amenities?.length || 0 + activities?.length || 0 + hotelType?.length || 0;
  const [popupOpenState, setPopupOpenState] = useState<boolean>(false);
  const [isNewFacetsLoading, setIsNewFacetsLoading] = useState<boolean>(props?.isNewFacetsLoading);
  const [filterCategoryModal, setFilterCategoryModal] = useState<string>('All Filters');
  const [filterCategoryHeader, setFilterCategoryHeader] = useState<string>(model?.allFilters ?? '');
  //brand
  const [selectedBrands, setSelectedBrands] = useState<BrandProps[]>([]);
  //amenities
  const [selectedAmenities, setSelectedAmenities] = useState<ControlsProps[]>(props?.selectedAmenities);
  //transportation
  const [selectedTransportaion, setSelectedTransportaion] = useState<ControlsProps[]>([]);
  // hotel type
  const [selectedHotelType, setSelectedHotelType] = useState<ControlsProps[]>(props?.selectedHotelType);
  //events
  const [selectedEvents, setSelectedEvents] = useState<ControlsProps[]>([]);
  //activities
  const [selectedActivities, setSelectedActivities] = useState<ControlsProps[]>(props?.selectedActivities);
  //prices
  const [selectedPrices, setSelectedPrices] = useState<ControlsProps[]>([
    {
      label: model?.anyPriceLabel,
      disabled: false,
    },
  ]);
  //currency
  const [selectedCurrency, setSelectedCurrency] = useState<ControlsProps[]>(props?.selectedCurrency);
  //city
  const [selectedCity, setSelectedCity] = useState<ControlsProps[]>([]);
  //state
  const [selectedState, setSelectedState] = useState<ControlsProps[]>([]);
  //availability
  const [includeUnavailableProperties, setIncludeUnavailableProperties] = useState<boolean>(
    props?.includeUnavailableProperties
  );
  const [isTaxSliderActive, setIsTaxSliderActive] = useState<boolean>(props?.isTaxSliderActive);

  const globalData = usePersistentGlobalStore((state: any) => state.globalData);
  // Prioritize server-side session data for initial render to prevent flicker
  const ariesOfferFromServer = props?.sessionData?.cacheData?.data?.AriesOffer;
  const ariesOfferFromGlobal = globalData?.sessionData?.cacheData?.data?.AriesOffer;
  // Use server data on initial render, then switch to global store after client-side updates
  const ariesOffer = props?.cliensideData
    ? ariesOfferFromGlobal ?? ariesOfferFromServer
    : ariesOfferFromServer || ariesOfferFromGlobal;

  const [isCategoryFilterModal, setIsCategoryFilterModal] = useState<boolean>(false);
  const isFilterSelected =
    ariesOffer === undefined || (!props?.cliensideData && model?.hasdestinationChanged)
      ? defaultFilterCount
      : (ariesOffer?.['selectedBrands']?.length ?? 0) +
        (ariesOffer?.['selectedAmenities']?.length ?? 0) +
        (ariesOffer?.['selectedTransportaion']?.length ?? 0) +
        (ariesOffer?.['selectedHotelType']?.length ?? 0) +
        (ariesOffer?.['selectedEvents']?.length ?? 0) +
        (ariesOffer?.['selectedActivities']?.length ?? 0) +
        (ariesOffer?.['selectedPrices']?.length > 0
          ? ariesOffer?.['selectedPrices']?.[0]?.label !== (model?.anyPriceLabel ?? 'Any Price')
            ? 1
            : 0
          : 0) +
        (ariesOffer?.['selectedCurrency']?.length > 0
          ? ariesOffer?.['selectedCurrency']?.[0]?.label !== (model?.defaultLabel ?? 'Default')
            ? 1
            : 0
          : 0) +
        (ariesOffer?.['selectedCity']?.length ?? 0) +
        (ariesOffer?.['selectedState']?.length ?? 0);
  const priceLabel = ariesOffer?.['selectedPrices']?.[0]?.label;
  const currencyLabel = ariesOffer?.['selectedCurrency']?.[0]?.label;
  const isPriceFilterSelected =
    (priceLabel && priceLabel !== (model?.anyPriceLabel ?? 'Any Price')) ||
    (currencyLabel && currencyLabel !== (model?.defaultLabel ?? 'Default'));
  const currencyOptions = [
    {
      label: model?.defaultLabel ?? 'Default',
      code: '',
    },
    {
      label: 'USD',
      code: 'USD',
    },
    {
      label: 'AUD',
      code: 'AUD',
    },
    {
      label: 'CAD',
      code: 'CAD',
    },
    {
      label: 'EUR',
      code: 'EUR',
    },
    {
      label: 'GBP',
      code: 'GBP',
    },
    {
      label: 'HKD',
      code: 'HKD',
    },
    {
      label: 'JPY',
      code: 'JPY',
    },
    {
      label: 'MXN',
      code: 'MXN',
    },
    {
      label: 'CNY',
      code: 'CNY',
    },
    {
      label: 'ZAR',
      code: 'ZAR',
    },
    {
      label: 'IDR',
      code: 'IDR',
    },
    {
      label: 'RUB',
      code: 'RUB',
    },
  ];
  const brandCategoriesData: brandCategoriesDataType = [];

  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startX, setStartX] = useState<number>(0);
  const [scrollLeft, setScrollLeft] = useState<number>(0);
  const containerRef: any = useRef(null);

  const checkArrayEquality = (arr1: any, arr2: any, filterType?: any): any => {
    if (filterType === 'price') {
      return !arr2 ? true : arr1?.[0]?.label === arr2?.[0]?.label;
    } else {
      if (!arr2?.length) {
        return true;
      } else if (arr1?.length !== arr2?.length) return false;
      const filterCodes1 = arr1
        ?.map((item: any) => {
          return item?.code;
        })
        ?.sort();
      const filterCodes2 = arr2
        ?.map((item: any) => {
          return item?.code;
        })
        .sort();

      return filterCodes1?.every((val: any, index: number) => {
        return val === filterCodes2?.[index];
      });
    }
  };
  const isOnlyCurrencyFilterUpdated = () => {
    const isOnlyCurrencySelected =
      checkArrayEquality(selectedBrands, ariesOffer?.['selectedBrands']) &&
      checkArrayEquality(selectedAmenities, ariesOffer?.['selectedAmenities']) &&
      checkArrayEquality(selectedTransportaion, ariesOffer?.['selectedTransportaion']) &&
      checkArrayEquality(selectedHotelType, ariesOffer?.['selectedHotelType']) &&
      checkArrayEquality(selectedEvents, ariesOffer?.['selectedEvents']) &&
      checkArrayEquality(selectedActivities, ariesOffer?.['selectedActivities']) &&
      checkArrayEquality(selectedPrices, ariesOffer?.['selectedPrices'], 'price') &&
      checkArrayEquality(selectedCity, ariesOffer?.['selectedCity']) &&
      checkArrayEquality(selectedState, ariesOffer?.['selectedState']) &&
      (includeUnavailableProperties === ariesOffer?.['includeUnavailableProperties'] ? true : false) &&
      (isTaxSliderActive === ariesOffer?.['showPricesTax'] ? true : false) &&
      false;
    return isOnlyCurrencySelected;
  };

  const handleMouseDown = (e: any) => {
    setIsDragging(true);

    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseMove = (e: any) => {
    if (!isDragging) return;
    const x = e.pageX - containerRef.current.offsetLeft;
    const distance = x - startX;
    containerRef.current.scrollLeft = scrollLeft - distance;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    setSelectedBrands(props?.selectedBrands);
    setSelectedAmenities(props?.selectedAmenities);
    setSelectedTransportaion(props?.selectedTransportaion);
    setSelectedHotelType(props?.selectedHotelType);
    setSelectedEvents(props?.selectedEvents);
    setSelectedActivities(props?.selectedActivities);
    setSelectedPrices(props?.selectedPrices);
    setSelectedCurrency(props?.selectedCurrency);
    setSelectedCity(props?.selectedCity);
    setSelectedState(props?.selectedState);
    setIncludeUnavailableProperties(props?.includeUnavailableProperties);
    setIsTaxSliderActive(props?.isTaxSliderActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props?.selectedBrands?.length,
    props?.selectedAmenities?.length,
    props?.selectedTransportaion?.length,
    props?.selectedHotelType?.length,
    props?.selectedEvents?.length,
    props?.selectedActivities?.length,
    props?.selectedPrices?.length,
    props?.selectedCurrency?.length,
    props?.selectedCity?.length,
    props?.selectedState?.length,
    props?.includeUnavailableProperties,
    props?.isTaxSliderActive,
  ]);

  useEffect(() => {
    setIsNewFacetsLoading(props?.isNewFacetsLoading);
  }, [props?.isNewFacetsLoading]);

  const brandCategoryTitleMapping: brandCategoryTitleMappingType = {
    luxuryBrands: model?.storefrontPropertyBrandFilterLuxury,
    premiumBrands: model?.storefrontPropertyBrandFilterPremium,
    selectBrands: model?.storefrontPropertyBrandFilterSelect,
    longerStayBrands: model?.storefrontPropertyBrandFilterLongerStay,
  };
  const authoredBrandsList: any = model?.brands;
  const getBrandCategoriesData = (brandCategory: string) => {
    const brandsList = authoredBrandsList?.[brandCategory]?.map((brand: { code: string; title: string }) => {
      const isDisabled = props?.availableBrands?.some((item: availableBrandsType) => {
        return item.code === brand.code;
      });
      return {
        code: brand?.code,
        brandTagTitle: brand?.title,
        description: '',
        brandTagId: brand?.code,
        isDisabled: !isDisabled,
      };
    });
    const key = brandCategory as keyof typeof brandCategoryTitleMapping; // to allow indexing on object
    const category = {
      categoryTitle: brandCategoryTitleMapping[key],
      categorySelectLabel: model?.storefrontPropertyBrandFilterSelectAll,
      categoryClearLabel: model?.storefrontPropertyFilterClear,
      brands: brandsList,
    };
    brandCategoriesData.push(category);
  };
  getBrandCategoriesData('luxuryBrands');
  getBrandCategoriesData('premiumBrands');
  getBrandCategoriesData('selectBrands');
  getBrandCategoriesData('longerStayBrands');

  const handleClearBtn = () => {
    if (filterCategoryModal === 'All Filters') {
      setIsNewFacetsLoading(true);
      //clear brands
      setSelectedBrands([]);
      props.handleDynamicBrands([]);
      //clear ammenities
      setSelectedAmenities([]);
      props?.handleDynamicAmenities([]);
      //clear transportation
      setSelectedTransportaion([]);
      props?.handleDynamicTransportaion([]);
      //clear hotels
      setSelectedHotelType([]);
      props?.handleDynamicHotelTypes([]);
      //clear events
      setSelectedEvents([]);
      props?.handleDynamicEvents([]);
      //clear activities
      setSelectedActivities([]);
      props?.handleDynamicActivities([]);
      //clear city
      setSelectedCity([]);
      props?.handleDynamicCities([]);
      //clear state
      setSelectedState([]);
      props?.handleDynamicStates([]);
      //clear price
      setSelectedPrices([
        {
          label: model?.anyPriceLabel,
          disabled: false,
        },
      ]);
      props?.handleDynamicPrices([
        {
          label: model?.anyPriceLabel,
          disabled: false,
        },
      ]);
      setSelectedCurrency([
        {
          label: model?.defaultLabel ?? 'Default',
          code: '',
          disabled: false,
        },
      ]);
      props?.handleDynamicCurrency([
        {
          label: model?.defaultLabel ?? 'Default',
          code: props?.defaultCurrency,
          disabled: false,
        },
      ]);
      setIsTaxSliderActive(props?.defaultTaxFlag);
      props?.handleDynamicPricesAndTax(props?.defaultTaxFlag);
      // clear unavailable properties filter
      setIncludeUnavailableProperties(true);
      props?.handleDynamicIncludeUnavailableProperties(true);
    } else if (filterCategoryModal === 'Brands') {
      setIsNewFacetsLoading(true);
      setSelectedBrands([]);
      props.handleDynamicBrands([]);
    } else if (filterCategoryModal === 'Amenities') {
      setIsNewFacetsLoading(true);
      setSelectedAmenities([]);
      props?.handleDynamicAmenities([]);
    } else if (filterCategoryModal === 'Price') {
      if (selectedPrices?.[0]?.label !== model?.anyPriceLabel) {
        setIsNewFacetsLoading(true);
        setSelectedPrices([
          {
            label: model?.anyPriceLabel,
            disabled: false,
          },
        ]);
        props?.handleDynamicPrices([
          {
            label: model?.anyPriceLabel,
            disabled: false,
          },
        ]);
      }
      setSelectedCurrency([
        {
          label: model?.defaultLabel ?? 'Default',
          code: '',
          disabled: false,
        },
      ]);
      props?.handleDynamicCurrency([
        {
          label: model?.defaultLabel ?? 'Default',
          code: '',
          disabled: false,
        },
      ]);
      setIsTaxSliderActive(props?.defaultTaxFlag);
      props?.handleDynamicPricesAndTax(props?.defaultTaxFlag);
    } else if (filterCategoryModal === 'Activities') {
      setIsNewFacetsLoading(true);
      setSelectedActivities([]);
      props?.handleDynamicActivities([]);
    } else if (filterCategoryModal === 'Events') {
      setIsNewFacetsLoading(true);
      setSelectedEvents([]);
      props?.handleDynamicEvents([]);
    } else if (filterCategoryModal === 'HotelType') {
      setIsNewFacetsLoading(true);
      setSelectedHotelType([]);
      props?.handleDynamicHotelTypes([]);
    } else if (filterCategoryModal === 'Transportation') {
      setIsNewFacetsLoading(true);
      setSelectedTransportaion([]);
      props?.handleDynamicTransportaion([]);
    }
    props?.handleClearAllFilters(filterCategoryModal);
  };
  const getControlsData = (currentFilterData: any, filterName?: string) => {
    if (!currentFilterData || currentFilterData?.length === 0) {
      return [];
    }
    if (filterName === 'price') {
      const desiredKeys = ['count', 'end', 'start'];
      const updatedPriceOptions = currentFilterData?.map((obj: any) => {
        const newPriceObj: any = {};
        desiredKeys?.forEach(key => {
          newPriceObj[key] = obj[key];
        });
        return newPriceObj;
      });
      const modifiedPriceOptions = updatedPriceOptions?.map((item: any) => ({
        count: item.count,
        label:
          item?.end === 'overflow'
            ? `${parseFloat(item.start)}+ USD`
            : `${parseFloat(item.start)} - ${parseFloat(item.end)} USD`,
        disabled: Number(item?.count) === 0,
      }));
      modifiedPriceOptions?.unshift({
        label: model?.anyPriceLabel,
      });
      return modifiedPriceOptions ?? [];
    } else {
      const desiredKeys = ['code', 'count', 'label', 'description'];
      const updatedFilterOptions = currentFilterData?.map((obj: any) => {
        const newFilterOptionsObj: any = {};
        desiredKeys?.forEach(key => {
          newFilterOptionsObj[key] = obj[key];
        });
        const modifiedLabel = obj?.label ?? obj?.description ?? obj?.code;
        return { ...newFilterOptionsObj, label: modifiedLabel };
      });
      return updatedFilterOptions ?? [];
    }
  };

  const handleBrandFilter = (selectedBrandAr: BrandProps[]) => {
    const uniqueBrands = Array.from(new Map(selectedBrandAr.map((item: any) => [item.code, item])).values());
    setIsNewFacetsLoading(true);
    setSelectedBrands(uniqueBrands);
    props?.handleDynamicBrands(uniqueBrands);
  };

  //props received by BrandFilter
  const BrandFilterProps: brandFilterProps = {
    title: `${model?.storefrontPropertyBrandFilter}`,
    brandCategories: brandCategoriesData,
    showSeparator: false,
    // defaultSelected includes all those brands which are selected and highlited for filtering the properties.
    defaultSelected: selectedBrands,
    onChange: handleBrandFilter,
    isHotelBrandSelectedFlag: true,
    clickTrackingVal: `${model?.storefrontPropertyBrandFilter} ${model?.storefrontPropertyFilters}`,
    clickTrackingLoc: `${model?.trackingProperties?.location}`,
    featureFlagLogo: props?.featureFlagLogo?.experience_mcom_logo_automation,
  };
  //handle amenities filter
  const handleAmenitiesChange = (selectedAmenitiesAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedAmenities(selectedAmenitiesAr);
    props?.handleDynamicAmenities(selectedAmenitiesAr);
  };

  const getSelectedAmenities = (allAmenities: any, selectedAmenitiesList: ControlsProps[]) => {
    const selectedAmenitiesCode = selectedAmenitiesList?.map(item => item.code);
    return allAmenities?.filter((item: any) => selectedAmenitiesCode?.includes(item.code)) ?? [];
  };
  const AmenitiesFilterProps: CheckboxControlsListProps = {
    title: `${model?.amenitiesLabel}`,
    controls: getControlsData(props?.availabledAmenities),
    enableShowMoreToggle: true,
    defaultSelected: getSelectedAmenities(props?.availabledAmenities, selectedAmenities),
    onChange: handleAmenitiesChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'Amenities',
    showSeparator: true,
  };
  //handle transportaion filter
  const handleTransportationChange = (selectedTransportationAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedTransportaion(selectedTransportationAr);
    props?.handleDynamicTransportaion(selectedTransportationAr);
  };
  const TransportationFilterProps: CheckboxControlsListProps = {
    title: `${model?.transportationLabel}`,
    controls: getControlsData(props?.availableTransportaion),
    enableShowMoreToggle: true,
    defaultSelected: selectedTransportaion,
    onChange: handleTransportationChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'Transportation',
    showSeparator: true,
  };
  //handle hotel type filter
  const handleHotelTypeChange = (selectedHotelTypeAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedHotelType(selectedHotelTypeAr);
    props?.handleDynamicHotelTypes(selectedHotelTypeAr);
  };
  const getSelectedHotelType = (allHotelType: any, selectedHotelTypeList: ControlsProps[]) => {
    const selectedHotelTypeCode = selectedHotelTypeList?.map(item => item.code);
    return allHotelType?.filter((item: any) => selectedHotelTypeCode?.includes(item.code)) ?? [];
  };
  const HotelTypeFilterProps: CheckboxControlsListProps = {
    title: `${model?.hotelTypeSearchLabel}`,
    controls: getControlsData(props?.availableHotelType),
    enableShowMoreToggle: true,
    defaultSelected: getSelectedHotelType(props?.availableHotelType, selectedHotelType),
    onChange: handleHotelTypeChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'HotelType',
    showSeparator: true,
  };
  //handle events filter
  const handleEventsChange = (selectedEventsAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedEvents(selectedEventsAr);
    props?.handleDynamicEvents(selectedEventsAr);
  };
  const getSelectedEvents = (allEvent: any, selectedEventList: ControlsProps[]) => {
    const selectedHotelTypeCode = selectedEventList?.map(item => item.code);
    return allEvent?.filter((item: any) => selectedHotelTypeCode?.includes(item.code)) ?? [];
  };
  const EventsFilterProps: CheckboxControlsListProps = {
    title: `${model?.eventsLabel}`,
    controls: getControlsData(props?.availablEvents),
    enableShowMoreToggle: true,
    defaultSelected: getSelectedEvents(props?.availablEvents, selectedEvents),
    onChange: handleEventsChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'Events',
    showSeparator: true,
  };
  //handle activities filter
  const handleActivitiesChange = (selectedActivitiesAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedActivities(selectedActivitiesAr);
    props?.handleDynamicActivities(selectedActivitiesAr);
  };
  const getSelectedActivities = (allActivities: any, selectedActivitiesList: ControlsProps[]) => {
    const selectedActivitiesCode = selectedActivitiesList?.map(item => item.code);
    return allActivities?.filter((item: any) => selectedActivitiesCode?.includes(item.code)) ?? [];
  };
  const ActivitiesFilterProps: CheckboxControlsListProps = {
    title: `${model?.activitiesLabel}`,
    controls: getControlsData(props?.availablActivities),
    enableShowMoreToggle: true,
    defaultSelected: getSelectedActivities(props?.availablActivities, selectedActivities),
    onChange: handleActivitiesChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'Activities',
    showSeparator: true,
  };
  //handle price filter
  const handlePricesChange = (selectedPrice: any) => {
    setIsNewFacetsLoading(true);
    setSelectedPrices(selectedPrice);
    props?.handleDynamicPrices(selectedPrice);
  };
  const PriceFilterProps: any = {
    title: `${model?.priceLabel}`,
    eyebrowText: `${model?.selectPricePerNightLabel}`,
    controls: getControlsData(props?.availablPrices, 'price'),
    enableShowMoreToggle: true,
    defaultSelected: selectedPrices,
    onChange: handlePricesChange,
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'price',
    showSeparator: false,
  };
  const PriceFilterPropsForPriceFilterModel: any = {
    eyebrowText: `${model?.selectPricePerNightLabel}`,
    controls: getControlsData(props?.availablPrices, 'price'),
    enableShowMoreToggle: false,
    defaultSelected: selectedPrices,
    onChange: handlePricesChange,
    name: 'price',
    showSeparator: false,
  };
  // handle currency filter
  const handleCurrencyChange = (selectedCurrency: any) => {
    setSelectedCurrency(selectedCurrency);
    props?.handleDynamicCurrency(selectedCurrency);
  };

  const currencyFilterProps: any = {
    eyebrowText: `${model?.showPriceInLabel ?? 'SHOW PRICE IN'}`,
    controls: currencyOptions,
    enableShowMoreToggle: true,
    defaultSelected: selectedCurrency,
    onChange: handleCurrencyChange,
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'currency',
    showSeparator: true,
  };
  const currencyFilterPropsForPriceFilterModel: any = {
    eyebrowText: `${model?.showPriceInLabel ?? 'SHOW PRICE IN'}`,
    controls: currencyOptions,
    enableShowMoreToggle: false,
    defaultSelected: selectedCurrency,
    onChange: handleCurrencyChange,
    name: 'currency',
    showSeparator: false,
  };
  //handle city filter
  const handleCityChange = (selectedCitiesAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedCity(selectedCitiesAr);
    props?.handleDynamicCities(selectedCitiesAr);
  };
  const CityFilterProps: CheckboxControlsListProps = {
    title: `${model?.cityLabel}`,
    controls: getControlsData(props?.availableCity, 'city'),
    enableShowMoreToggle: true,
    defaultSelected: selectedCity,
    onChange: handleCityChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'filterCity',
    showSeparator: true,
  };
  //handle state filter
  const handleStateChange = (selectedStateAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedState(selectedStateAr);
    props?.handleDynamicStates(selectedStateAr);
  };
  const StateFilterProps: CheckboxControlsListProps = {
    title: `${model?.stateLabel ?? 'State'}`,
    controls: getControlsData(props?.availablState),
    enableShowMoreToggle: true,
    defaultSelected: selectedState,
    onChange: handleStateChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'filterState',
    showSeparator: true,
  };
  //handle availability
  const handleAvailabilityChange = (val: boolean) => {
    setIsNewFacetsLoading(true);
    setIncludeUnavailableProperties(!val);
    props?.handleDynamicIncludeUnavailableProperties(!val);
  };
  const handleDynamicPricesAndTax = (val: boolean) => {
    setIsNewFacetsLoading(false);
    setIsTaxSliderActive(val);
    props?.handleDynamicPricesAndTax(val);
  };
  const toggleModal = () => {
    !popupOpenState && setIsNewFacetsLoading(true);
    setPopupOpenState(!popupOpenState);
    props?.handleDynamicBrands(ariesOffer?.['selectedBrands'] ?? []);
    props?.handleDynamicAmenities(ariesOffer?.['selectedAmenities'] ?? []);
    props?.handleDynamicTransportaion(ariesOffer?.['selectedTransportaion'] ?? []);
    props?.handleDynamicHotelTypes(ariesOffer?.['selectedHotelType'] ?? []);
    props?.handleDynamicEvents(ariesOffer?.['selectedEvents'] ?? []);
    props?.handleDynamicActivities(ariesOffer?.['selectedActivities'] ?? []);
    props?.handleDynamicPrices(
      ariesOffer?.['selectedPrices']?.length
        ? ariesOffer?.['selectedPrices']
        : [
            {
              label: `${model?.anyPriceLabel}`,
              disabled: false,
            },
          ]
    );
    props?.handleDynamicCurrency(
      ariesOffer?.['selectedCurrency']?.length ? ariesOffer?.['selectedCurrency'] : props?.selectedCurrency
    );
    props?.handleDynamicCities(ariesOffer?.['selectedCity'] ?? []);
    props?.handleDynamicStates(ariesOffer?.['selectedState'] ?? []);
    props?.handleDynamicIncludeUnavailableProperties(
      ariesOffer?.['includeUnavailableProperties'] === false ? false : true
    );
    props?.handleDynamicPricesAndTax(ariesOffer?.['showPricesTax'] ?? props?.defaultTaxFlag);
    setSelectedCity(ariesOffer?.['selectedCity'] ?? []);
    setSelectedBrands(ariesOffer?.['selectedBrands'] ?? []);
    setSelectedAmenities(ariesOffer?.['selectedAmenities'] ?? []);
    setSelectedTransportaion(ariesOffer?.['selectedTransportaion'] ?? []);
    setSelectedHotelType(ariesOffer?.['selectedHotelType'] ?? []);
    setSelectedEvents(ariesOffer?.['selectedEvents'] ?? []);
    setSelectedActivities(ariesOffer?.['selectedActivities'] ?? []);
    setSelectedPrices(
      ariesOffer?.['selectedPrices']?.length
        ? ariesOffer?.['selectedPrices']
        : [
            {
              label: `${model?.anyPriceLabel}`,
              disabled: false,
            },
          ]
    );
    setSelectedCurrency(
      ariesOffer?.['selectedCurrency']?.length ? ariesOffer?.['selectedCurrency'] : props?.selectedCurrency
    );
    setSelectedState(ariesOffer?.['selectedState'] ?? []);
    setIncludeUnavailableProperties(
      ariesOffer?.['includeUnavailableProperties'] === true
        ? true
        : ariesOffer?.['includeUnavailableProperties'] === false
        ? false
        : true
    );
    setIsTaxSliderActive(ariesOffer?.['showPricesTax'] ?? props?.defaultTaxFlag);
  };
  const filterLabel = {
    availabilityLabel: model?.availabilityLabel,
    showAvailableHotelsOnlyLabel: model?.showAvailableHotelsOnlyLabel,
    priceLabel: model?.priceLabel,
  };
  const getModalData = (): any => {
    if (filterCategoryModal === 'All Filters') {
      return (
        <>
          {!isCategoryRenderer && (
            <ShowAvailabilityFilter
              handleAvailabilityChange={handleAvailabilityChange}
              isSliderActive={!includeUnavailableProperties}
              labels={filterLabel}
            />
          )}
          <>
            {!isCategoryRenderer &&
            props?.showPricefilter &&
            PriceFilterProps.controls?.length > 0 &&
            !hidePriceRangeFilter ? (
              <RadiobuttonControlsList {...PriceFilterProps} />
            ) : null}
            {!isCategoryRenderer && props?.showPricefilter && (
              <ShowPriceTaxFilter
                isTaxSliderActive={isTaxSliderActive}
                handleDynamicPricesAndTax={handleDynamicPricesAndTax}
                filterTaxesLabel={model?.filterTaxesLabel}
                priceLabel={hidePriceRangeFilter ? model?.priceLabel : ''}
              />
            )}
            {!isCategoryRenderer && props?.showPricefilter && currencyFilterProps?.controls?.length > 0 ? (
              <RadiobuttonControlsList {...currencyFilterProps} />
            ) : null}
          </>

          {AmenitiesFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...AmenitiesFilterProps} /> : null}
          <BrandFilter {...BrandFilterProps} />

          {TransportationFilterProps?.controls?.length > 0 ? (
            <CheckboxControlsList {...TransportationFilterProps} />
          ) : null}
          {HotelTypeFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...HotelTypeFilterProps} /> : null}
          {EventsFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...EventsFilterProps} /> : null}
          {ActivitiesFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...ActivitiesFilterProps} /> : null}
          {StateFilterProps.controls?.length > 0 && props?.isStateEnabled === false ? (
            <CheckboxControlsList {...StateFilterProps} />
          ) : null}
          {CityFilterProps.controls?.length > 0 ? <CheckboxControlsList {...CityFilterProps} /> : null}
        </>
      );
    } else if (filterCategoryModal === 'Price') {
      return (
        <>
          {PriceFilterPropsForPriceFilterModel.controls?.length > 0 && !hidePriceRangeFilter ? (
            <div className="priceFilterRadioWrapper">
              <RadiobuttonControlsList {...PriceFilterPropsForPriceFilterModel} />
            </div>
          ) : null}
          {props?.showPricefilter ? (
            <ShowPriceTaxFilter
              isTaxSliderActive={isTaxSliderActive}
              handleDynamicPricesAndTax={handleDynamicPricesAndTax}
              filterTaxesLabel={model?.filterTaxesLabel}
            />
          ) : null}
          {currencyFilterPropsForPriceFilterModel?.controls?.length > 0 ? (
            <RadiobuttonControlsList {...currencyFilterPropsForPriceFilterModel} />
          ) : null}
        </>
      );
    } else if (filterCategoryModal === 'Amenities') {
      return AmenitiesFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...AmenitiesFilterProps} /> : null;
    } else if (filterCategoryModal === 'Brands') {
      return <BrandFilter {...BrandFilterProps} />;
    } else if (filterCategoryModal === 'Activities') {
      return ActivitiesFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...ActivitiesFilterProps} /> : null;
    } else if (filterCategoryModal === 'Events') {
      return EventsFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...EventsFilterProps} /> : null;
    } else if (filterCategoryModal === 'HotelType') {
      return HotelTypeFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...HotelTypeFilterProps} /> : null;
    } else if (filterCategoryModal === 'Transportation') {
      return TransportationFilterProps?.controls?.length > 0 ? (
        <CheckboxControlsList {...TransportationFilterProps} />
      ) : null;
    }
  };

  return (
    <StyledSearchAllFilters className="offer-filters">
      <div
        className="filter-btns-wrapper"
        id="filter-btns-wrapper"
        ref={containerRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        <Button
          callback={() => {
            setFilterCategoryModal('All Filters');
            setFilterCategoryHeader(model?.allFilters);
            toggleModal();
          }}
          className={clsx(
            `button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button ${
              isFilterSelected && 'active'
            }`
          )}
          custom_click_track_value={`${model?.id}|${model?.allFilters}|${INTERNAL_CTA_TYPE}`}
        >
          <span className={`icon-s ${isFilterSelected ? ' all-filter-badge' : 'icon-dining-filter'}`}>
            {' '}
            {`${isFilterSelected ? isFilterSelected : ''}`}
          </span>
          <span className="all-filter-text"> {model?.allFilters}</span>
        </Button>
        {!isCategoryRenderer && props?.showPricefilter ? (
          <Button
            callback={(): void => {
              setFilterCategoryModal('Price');
              setFilterCategoryHeader(model?.priceLabel);
              toggleModal();
            }}
            className={clsx(
              `button custom_click_track button--medium button-secondary m-button-primary-inverse filter-option-button ${
                isPriceFilterSelected ? 'active' : ''
              }`
            )}
            custom_click_track_value={`${model?.id}|${model?.priceLabel}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.priceLabel}
          </Button>
        ) : (
          ''
        )}
        {(!isCategoryRenderer || hasQuickFilter('amenities')) && (
          <Button
            callback={(): void => {
              setFilterCategoryModal('Amenities');
              setFilterCategoryHeader(model?.amenitiesLabel);
              toggleModal();
            }}
            className={clsx(
              'button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button',
              ariesOffer?.['selectedAmenities']?.length > 0 ? 'active' : ''
            )}
            custom_click_track_value={`${model?.id}|${model?.amenitiesLabel}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.amenitiesLabel}
          </Button>
        )}
        {(!isCategoryRenderer || hasQuickFilter('brands')) && (
          <Button
            callback={(): void => {
              setFilterCategoryModal('Brands');
              setFilterCategoryHeader(model?.storefrontPropertyBrandFilter);
              toggleModal();
            }}
            className={clsx(
              'button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button',
              ariesOffer?.['selectedBrands']?.length > 0 ? 'active' : ''
            )}
            custom_click_track_value={`${model?.id}|${model?.storefrontPropertyBrandFilter}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.storefrontPropertyBrandFilter}
          </Button>
        )}
        {isCategoryRenderer && hasQuickFilter('activities') && (
          <Button
            callback={(): void => {
              setFilterCategoryModal('Activities');
              setFilterCategoryHeader(model?.activitiesLabel);
              toggleModal();
            }}
            className={clsx(
              'button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button',
              ariesOffer?.['selectedActivities']?.length > 0 ? 'active' : ''
            )}
            custom_click_track_value={`${model?.id}|${model?.activitiesLabel}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.activitiesLabel}
          </Button>
        )}
        {isCategoryRenderer && hasQuickFilter('events') && (
          <Button
            callback={(): void => {
              setFilterCategoryModal('Events');
              setFilterCategoryHeader(model?.eventsLabel);
              toggleModal();
            }}
            className={clsx(
              'button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button',
              ariesOffer?.['selectedEvents']?.length > 0 ? 'active' : ''
            )}
            custom_click_track_value={`${model?.id}|${model?.eventsLabel}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.eventsLabel}
          </Button>
        )}
        {isCategoryRenderer && hasQuickFilter('property-type') && (
          <Button
            callback={(): void => {
              setFilterCategoryModal('HotelType');
              setFilterCategoryHeader(model?.hotelTypeSearchLabel);
              toggleModal();
            }}
            className={clsx(
              'button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button',
              ariesOffer?.['selectedHotelType']?.length > 0 ? 'active' : ''
            )}
            custom_click_track_value={`${model?.id}|${model?.hotelTypeSearchLabel}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.hotelTypeSearchLabel}
          </Button>
        )}
        {isCategoryRenderer && hasQuickFilter('transportation') && (
          <Button
            callback={(): void => {
              setFilterCategoryModal('Transportation');
              setFilterCategoryHeader(model?.transportationLabel);
              toggleModal();
            }}
            className={clsx(
              'button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button',
              ariesOffer?.['selectedTransportaion']?.length > 0 ? 'active' : ''
            )}
            custom_click_track_value={`${model?.id}|${model?.transportationLabel}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.transportationLabel}
          </Button>
        )}
      </div>
      {popupOpenState && (
        <Modal
          className={`custom-scrollbar modal-main-container ${popupOpenState && 'close-popup-header'} ${
            isCategoryFilterModal && 'category-filter-modal'
          }`}
          show={true}
          handleBlur={true}
          popupOpenState={popupOpenState}
          setPopupOpenState={setPopupOpenState}
          disableScrollOnBody={true}
          allFilterPopUp={true}
          onClose={(): void => {
            toggleModal();
          }}
        >
          {isNewFacetsLoading && (
            <div
              className="loader-container d-flex align-items-center justify-content-center"
              data-testid="facets-spinner"
            >
              <div className="m-spinner-m"></div>
            </div>
          )}
          <Modal.Header
            className="modal-header t-subtitle-xl"
            labelText={filterCategoryHeader}
            popupHeaderOnCLoseFunc={(): void => {
              setIsCategoryFilterModal(false);
              setPopupOpenState(false);
            }}
            closeIconClickTrackValue={`${model?.id}|${model?.close ?? 'CloseModal'}|${INTERNAL_CTA_TYPE}`}
          />
          <Modal.Body className="all-filters custom-scrollbar">
            <div>{getModalData()}</div>
          </Modal.Body>
          <Modal.Footer
            clearClickHandler={handleClearBtn}
            setPopUpOpenState={setPopupOpenState}
            applyBtnClickHandler={() => {
              isOnlyCurrencyFilterUpdated()
                ? props?.handleApplyCurrencyFilter(selectedCurrency)
                : props?.handleApplyFilter(
                    selectedBrands,
                    selectedAmenities,
                    selectedTransportaion,
                    selectedHotelType,
                    selectedEvents,
                    selectedActivities,
                    selectedPrices,
                    selectedCurrency,
                    selectedCity,
                    selectedState,
                    includeUnavailableProperties,
                    isTaxSliderActive
                  );
            }}
            clearButtonLabel={model?.clearFilters}
            applyLabel={model?.storefrontPropertyFilterApply}
            className="modal-footer"
            clickTrackingLoc={'SEARCH_FILTER_MODAL'}
            applyBtnClickTrackValue={`${model?.id}|${model?.storefrontPropertyFilterApply}|${INTERNAL_CTA_TYPE}`}
            clearBtnClickTrackValue={`${model?.id}|${model?.clearFilters}|${INTERNAL_CTA_TYPE}`}
          />
        </Modal>
      )}
    </StyledSearchAllFilters>
  );
};
